export class FindAllGroupMembers {
  public static readonly type = '[Group/Users/List] FindAllGroupMembers';
}
